export const PAGE_HASHES = {
  catalog: "#vl-7f3a9c",
  locations: "#vl-2d8b41",
  suggestions: "#vl-5a6e2d",
  team: "#vl-9c4b17",
};

export const pageFromHash = (hash) =>
  Object.entries(PAGE_HASHES).find(([, pageHash]) => pageHash === hash)?.[0] || "home";
